import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["dropdown", "form", "signatureContainer", "signature1Input", "signature2Input"];

  static values = {
    originalTemplateId: String,
    updateConfirmTitle: String,
    updateConfirmMessage: String,
    updateConfirmAllow: String,
    removeConfirmTitle: String,
    removeConfirmMessage: String,
    removeConfirmAllow: String,
    confirmCancel: String
  };

  submit(event) {
    event.preventDefault();

    if (!this._templateWasUpdated() || !this.formTarget.checkValidity()) {
      this._submitForm();
      return;
    }

    this._submitWithConfirmation();
  }

  _submitForm() {
    this.formTarget.requestSubmit();
  }

  _submitWithConfirmation() {
    let confirmData;

    if (this.selectedValue) {
      confirmData = this._updateConfirmationModalDataset();
    } else {
      confirmData = this._removeConfirmationModalDataset();
    }

    const confirmed = Rails.confirm(null, event.target, confirmData);

    if (!confirmed) {
      return;
    }

    this._submitForm();
  }

  _updateConfirmationModalDataset() {
    return {
      confirmTitle: this.updateConfirmTitleValue,
      confirmMessage: this.updateConfirmMessageValue,
      confirmAllow: this.updateConfirmAllowValue,
      confirmCancel: this.confirmCancelValue
    };
  }

  _removeConfirmationModalDataset() {
    return {
      confirmError: true,
      confirmTitle: this.removeConfirmTitleValue,
      confirmMessage: this.removeConfirmMessageValue,
      confirmAllow: this.removeConfirmAllowValue,
      confirmCancel: this.confirmCancelValue
    };
  }

  templateChanged(event) {
    const { hasSignature1, hasSignature2 } = event.currentTarget.dataset;

    const showSignature1 = hasSignature1 === 'true';
    const showSignature2 = hasSignature2 === 'true';

    this.signatureContainerTarget.classList
      .toggle('hidden', !showSignature1 && !showSignature2);

    this.signature1InputTarget.required = showSignature1;
    this.signature1InputTarget.closest('fieldset')
      .classList.toggle('hidden', !showSignature1);

    this.signature2InputTarget.required = showSignature2;
    this.signature2InputTarget.closest('fieldset')
      .classList.toggle('hidden', !showSignature2);
  }

  _templateWasUpdated() {
    return this.originalValue && this.selectedValue !== this.originalValue;
  }

  get selectedValue() {
    return this.dropdownTarget.querySelector('input[type="hidden"]')?.value || '';
  }

  get originalValue() {
    return this.originalTemplateIdValue || '';
  }
}
